export default __webpack_public_path__ + "static/a2-02dc03935b73d1240ecce9958e121352.png";